var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMoreVertical = function SvgIconMoreVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4.181,
    height: 19.447,
    viewBox: "0 0 4.181 19.447",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.681,17.59a1.09,1.09,0,1,1-1.09-1.09A1.09,1.09,0,0,1,18.681,17.59Z",
    transform: "translate(0 -2.867)",
    fill: "#8d8585",
    stroke: "#8d8585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.681,7.09A1.09,1.09,0,1,1,17.59,6a1.09,1.09,0,0,1,1.09,1.09Z",
    fill: "#8d8585",
    stroke: "#8d8585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.681,28.09A1.09,1.09,0,1,1,17.59,27,1.09,1.09,0,0,1,18.681,28.09Z",
    transform: "translate(0 -5.734)",
    fill: "#8d8585",
    stroke: "#8d8585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMoreVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-more-vertical.62a5b096.svg";
export { ForwardRef as ReactComponent };